"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _atomParser = _interopRequireDefault(require("./atom-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Atom - An atom represents a section of data in a mpeg file
 */
var Atom =
/*#__PURE__*/
function () {
  /**
   * constructor - Atom - An atom represents a section of data in a mpeg file
   *
   * @param  {String}     name     Name of the atom (4 characters)
   * @param  {Integer}    location Location of the beginning of the atom (where size starts)
   * @param  {Integer}    size     Size of the atom reported from the 32bit size integer
   * @param  {Uint8Array} payload  The actual atom data (starting after the atom name)
   * @return {Atom}                Atom struct with appropriate fields
   */
  function Atom(name, location, size, payload) {
    _classCallCheck(this, Atom);

    this.name = name;
    this.location = location;
    this.size = size;

    if (_atomParser.default[name]) {
      _atomParser.default[name](this, payload);
    }
  }
  /**
   * insert - Insert a child atom into a parent atom
   *
   * @param  {Atom} child An atom which is a descendant of a media atom
   */


  _createClass(Atom, [{
    key: "insert",
    value: function insert(child) {
      if (!this.children) {
        this.children = [];
      }

      this.children.push(child);
    }
  }]);

  return Atom;
}();

var _default = Atom;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/fmp4/atom.js
// module id = 202
// module chunks = 0